/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AcceptDocumentCommand } from '../models/accept-document-command';
import { BasicDocumentType } from '../models/basic-document-type';
import { CheckDocumentValidityDateCommand } from '../models/check-document-validity-date-command';
import { CreateOrUpdateDocumentGroupCommand } from '../models/create-or-update-document-group-command';
import { DocumentGroupData } from '../models/document-group-data';
import { ListDocumentGroupsQuery } from '../models/list-document-groups-query';
import { ListDocumentGroupsResult } from '../models/list-document-groups-result';
import { ListDocumentsQuery } from '../models/list-documents-query';
import { ListDocumentsResult } from '../models/list-documents-result';
import { RemoveDocumentCommand } from '../models/remove-document-command';
import { RemoveDocumentGroupCommand } from '../models/remove-document-group-command';
import { RemoveUploadedDocumentFileCommand } from '../models/remove-uploaded-document-file-command';
import { RestoreArchivedDocumentGroupCommand } from '../models/restore-archived-document-group-command';
import { UpdateDocumentCommand } from '../models/update-document-command';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation documentsList
   */
  static readonly DocumentsListPath = '/api/Documents/List';

  /**
   * Dokumentumcsaládok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsList$Plain$Response(params?: {
    body?: ListDocumentGroupsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListDocumentGroupsResult>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListDocumentGroupsResult>;
      })
    );
  }

  /**
   * Dokumentumcsaládok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsList$Plain(params?: {
    body?: ListDocumentGroupsQuery
  },
  context?: HttpContext

): Observable<ListDocumentGroupsResult> {

    return this.documentsList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListDocumentGroupsResult>) => r.body as ListDocumentGroupsResult)
    );
  }

  /**
   * Dokumentumcsaládok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsList$Response(params?: {
    body?: ListDocumentGroupsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListDocumentGroupsResult>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListDocumentGroupsResult>;
      })
    );
  }

  /**
   * Dokumentumcsaládok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsList(params?: {
    body?: ListDocumentGroupsQuery
  },
  context?: HttpContext

): Observable<ListDocumentGroupsResult> {

    return this.documentsList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListDocumentGroupsResult>) => r.body as ListDocumentGroupsResult)
    );
  }

  /**
   * Path part for operation documentsGet
   */
  static readonly DocumentsGetPath = '/api/Documents/Get';

  /**
   * Dokumentumcsalád lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGet$Plain$Response(params?: {
    Id?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<DocumentGroupData>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsGetPath, 'get');
    if (params) {
      rb.query('Id', params.Id, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentGroupData>;
      })
    );
  }

  /**
   * Dokumentumcsalád lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGet$Plain(params?: {
    Id?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<DocumentGroupData> {

    return this.documentsGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<DocumentGroupData>) => r.body as DocumentGroupData)
    );
  }

  /**
   * Dokumentumcsalád lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGet$Response(params?: {
    Id?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<DocumentGroupData>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsGetPath, 'get');
    if (params) {
      rb.query('Id', params.Id, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DocumentGroupData>;
      })
    );
  }

  /**
   * Dokumentumcsalád lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGet(params?: {
    Id?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<DocumentGroupData> {

    return this.documentsGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<DocumentGroupData>) => r.body as DocumentGroupData)
    );
  }

  /**
   * Path part for operation documentsPost
   */
  static readonly DocumentsPostPath = '/api/Documents/Post';

  /**
   * Dokumentumcsalád létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsPost$Plain$Response(params?: {
    body?: CreateOrUpdateDocumentGroupCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Dokumentumcsalád létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsPost$Plain(params?: {
    body?: CreateOrUpdateDocumentGroupCommand
  },
  context?: HttpContext

): Observable<string> {

    return this.documentsPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Dokumentumcsalád létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsPost$Response(params?: {
    body?: CreateOrUpdateDocumentGroupCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Dokumentumcsalád létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsPost(params?: {
    body?: CreateOrUpdateDocumentGroupCommand
  },
  context?: HttpContext

): Observable<string> {

    return this.documentsPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation documentsRemove
   */
  static readonly DocumentsRemovePath = '/api/Documents/Remove';

  /**
   * Dokumentumcsalád törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsRemove()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRemove$Response(params?: {
    body?: RemoveDocumentGroupCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsRemovePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Dokumentumcsalád törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsRemove$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRemove(params?: {
    body?: RemoveDocumentGroupCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.documentsRemove$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation documentsRestoreArchived
   */
  static readonly DocumentsRestoreArchivedPath = '/api/Documents/RestoreArchived';

  /**
   * Archivált dokumentumcsalád visszaállítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsRestoreArchived()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRestoreArchived$Response(params?: {
    body?: RestoreArchivedDocumentGroupCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsRestoreArchivedPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Archivált dokumentumcsalád visszaállítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsRestoreArchived$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRestoreArchived(params?: {
    body?: RestoreArchivedDocumentGroupCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.documentsRestoreArchived$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getDocumentFile
   */
  static readonly GetDocumentFilePath = '/api/Documents/uploads/{documentGroupId}/{documentId}';

  /**
   * Feltöltött dokumentum lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocumentFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentFile$Response(params: {
    documentGroupId: string;
    documentId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.GetDocumentFilePath, 'get');
    if (params) {
      rb.path('documentGroupId', params.documentGroupId, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Feltöltött dokumentum lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDocumentFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocumentFile(params: {
    documentGroupId: string;
    documentId: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.getDocumentFile$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation documentsUploadDocumentFile
   */
  static readonly DocumentsUploadDocumentFilePath = '/api/Documents/UploadDocumentFile';

  /**
   * Dokumentum fájl feltöltése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsUploadDocumentFile$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsUploadDocumentFile$Plain$Response(params?: {
    body?: {
'RequestUserId'?: number;
'File'?: Blob;
'DocumentGroupId'?: string;
'DocumentId'?: string;
'ValidityStart'?: string;
'MainChanges'?: string;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsUploadDocumentFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Dokumentum fájl feltöltése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsUploadDocumentFile$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsUploadDocumentFile$Plain(params?: {
    body?: {
'RequestUserId'?: number;
'File'?: Blob;
'DocumentGroupId'?: string;
'DocumentId'?: string;
'ValidityStart'?: string;
'MainChanges'?: string;
}
  },
  context?: HttpContext

): Observable<string> {

    return this.documentsUploadDocumentFile$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Dokumentum fájl feltöltése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsUploadDocumentFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsUploadDocumentFile$Response(params?: {
    body?: {
'RequestUserId'?: number;
'File'?: Blob;
'DocumentGroupId'?: string;
'DocumentId'?: string;
'ValidityStart'?: string;
'MainChanges'?: string;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsUploadDocumentFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Dokumentum fájl feltöltése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsUploadDocumentFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsUploadDocumentFile(params?: {
    body?: {
'RequestUserId'?: number;
'File'?: Blob;
'DocumentGroupId'?: string;
'DocumentId'?: string;
'ValidityStart'?: string;
'MainChanges'?: string;
}
  },
  context?: HttpContext

): Observable<string> {

    return this.documentsUploadDocumentFile$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation documentsRemoveFile
   */
  static readonly DocumentsRemoveFilePath = '/api/Documents/RemoveFile';

  /**
   * Dokumentum fájl törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsRemoveFile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRemoveFile$Response(params?: {
    body?: RemoveUploadedDocumentFileCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsRemoveFilePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Dokumentum fájl törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsRemoveFile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRemoveFile(params?: {
    body?: RemoveUploadedDocumentFileCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.documentsRemoveFile$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation documentsRemoveDocument
   */
  static readonly DocumentsRemoveDocumentPath = '/api/Documents/RemoveDocument';

  /**
   * Dokumentum törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsRemoveDocument()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRemoveDocument$Response(params?: {
    body?: RemoveDocumentCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsRemoveDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Dokumentum törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsRemoveDocument$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsRemoveDocument(params?: {
    body?: RemoveDocumentCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.documentsRemoveDocument$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation documentsUpdateDocument
   */
  static readonly DocumentsUpdateDocumentPath = '/api/Documents/UpdateDocument';

  /**
   * Dokumentum módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsUpdateDocument()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsUpdateDocument$Response(params?: {
    body?: UpdateDocumentCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsUpdateDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Dokumentum módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsUpdateDocument$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsUpdateDocument(params?: {
    body?: UpdateDocumentCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.documentsUpdateDocument$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation documentsListDocuments
   */
  static readonly DocumentsListDocumentsPath = '/api/Documents/ListDocuments';

  /**
   * Dokumentumok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsListDocuments$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsListDocuments$Plain$Response(params?: {
    body?: ListDocumentsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListDocumentsResult>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsListDocumentsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListDocumentsResult>;
      })
    );
  }

  /**
   * Dokumentumok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsListDocuments$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsListDocuments$Plain(params?: {
    body?: ListDocumentsQuery
  },
  context?: HttpContext

): Observable<ListDocumentsResult> {

    return this.documentsListDocuments$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListDocumentsResult>) => r.body as ListDocumentsResult)
    );
  }

  /**
   * Dokumentumok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsListDocuments()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsListDocuments$Response(params?: {
    body?: ListDocumentsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListDocumentsResult>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsListDocumentsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListDocumentsResult>;
      })
    );
  }

  /**
   * Dokumentumok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsListDocuments$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsListDocuments(params?: {
    body?: ListDocumentsQuery
  },
  context?: HttpContext

): Observable<ListDocumentsResult> {

    return this.documentsListDocuments$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListDocumentsResult>) => r.body as ListDocumentsResult)
    );
  }

  /**
   * Path part for operation documentsAcceptDocument
   */
  static readonly DocumentsAcceptDocumentPath = '/api/Documents/AcceptDocument';

  /**
   * Dokumentum elfogadása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsAcceptDocument$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsAcceptDocument$Plain$Response(params?: {
    body?: AcceptDocumentCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsAcceptDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Dokumentum elfogadása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsAcceptDocument$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsAcceptDocument$Plain(params?: {
    body?: AcceptDocumentCommand
  },
  context?: HttpContext

): Observable<number> {

    return this.documentsAcceptDocument$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Dokumentum elfogadása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsAcceptDocument()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsAcceptDocument$Response(params?: {
    body?: AcceptDocumentCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsAcceptDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Dokumentum elfogadása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsAcceptDocument$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsAcceptDocument(params?: {
    body?: AcceptDocumentCommand
  },
  context?: HttpContext

): Observable<number> {

    return this.documentsAcceptDocument$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation documentsGetLatestBasicDocumentLink
   */
  static readonly DocumentsGetLatestBasicDocumentLinkPath = '/api/Documents/GetLatestBasicDocumentLink';

  /**
   * Legfrissebb alapértelmezett dokumentum linkjének lekérdezése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGetLatestBasicDocumentLink$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetLatestBasicDocumentLink$Plain$Response(params?: {
    Type?: BasicDocumentType;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsGetLatestBasicDocumentLinkPath, 'get');
    if (params) {
      rb.query('Type', params.Type, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Legfrissebb alapértelmezett dokumentum linkjének lekérdezése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGetLatestBasicDocumentLink$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetLatestBasicDocumentLink$Plain(params?: {
    Type?: BasicDocumentType;
  },
  context?: HttpContext

): Observable<string> {

    return this.documentsGetLatestBasicDocumentLink$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Legfrissebb alapértelmezett dokumentum linkjének lekérdezése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsGetLatestBasicDocumentLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetLatestBasicDocumentLink$Response(params?: {
    Type?: BasicDocumentType;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsGetLatestBasicDocumentLinkPath, 'get');
    if (params) {
      rb.query('Type', params.Type, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Legfrissebb alapértelmezett dokumentum linkjének lekérdezése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsGetLatestBasicDocumentLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsGetLatestBasicDocumentLink(params?: {
    Type?: BasicDocumentType;
  },
  context?: HttpContext

): Observable<string> {

    return this.documentsGetLatestBasicDocumentLink$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation documentsCheckDocumentValidityDate
   */
  static readonly DocumentsCheckDocumentValidityDatePath = '/api/Documents/CheckDocumentValidityDate';

  /**
   * Foglalt dokumentum érvényességi idő vizsgálata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsCheckDocumentValidityDate$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsCheckDocumentValidityDate$Plain$Response(params?: {
    body?: CheckDocumentValidityDateCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsCheckDocumentValidityDatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Foglalt dokumentum érvényességi idő vizsgálata.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsCheckDocumentValidityDate$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsCheckDocumentValidityDate$Plain(params?: {
    body?: CheckDocumentValidityDateCommand
  },
  context?: HttpContext

): Observable<number> {

    return this.documentsCheckDocumentValidityDate$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Foglalt dokumentum érvényességi idő vizsgálata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsCheckDocumentValidityDate()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsCheckDocumentValidityDate$Response(params?: {
    body?: CheckDocumentValidityDateCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DocumentsCheckDocumentValidityDatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Foglalt dokumentum érvényességi idő vizsgálata.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsCheckDocumentValidityDate$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentsCheckDocumentValidityDate(params?: {
    body?: CheckDocumentValidityDateCommand
  },
  context?: HttpContext

): Observable<number> {

    return this.documentsCheckDocumentValidityDate$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
